import { OpCo } from '../types/type';

export const mapContactNumber = (opCoId: string, partnerName: string) => {
  let customerCareNumber = '';

  switch (opCoId) {
    case OpCo.AMFAM:
      customerCareNumber = '1-800-692-6326';
      break;
    case OpCo.MSA:
      customerCareNumber = '1-877-425-2467';
      break;
    case OpCo.HOMESITE:
      customerCareNumber = '1-833-854-1200';
      break;

    default:
      customerCareNumber = '1-800-692-6326';
      break;
  }

  return customerCareNumber;
};
